import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DropdownOption from 'components/Common/DropdownOption';
import Hashtag from 'components/Common/Hashtag';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { TYPE_IMAGE_OPTIONS } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useEffect, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import InfiniteScroll from 'react-infinite-scroll-component';
import Masonry from "react-masonry-component";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { deleteImageLibrary, getImageLibraryNormal, patchImageLibrary, postImageLibraryFavorite } from 'store/thunks';
import ImageBox from './ImageBox';
import ImportImageBulkForm from './ImportImageBulkForm';
import LibraryEditForm from './LibraryEditForm';
import LibraryForm from './LibraryForm';
export interface Tag {
  id: string;
  text: string;
}

registerLocale('en', en);
registerLocale('ko', ko);


const ImageRepository = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const SORT_OPTIONS_LANG: Option[] = [{ label: t('Latest'), value: 'created_at' }, { label: t('Most favorites'), value: 'total_favorites' }, { label: t('Most downloaded'), value: 'total_downloads' }];

  const TYPE_OPTIONS_LANG: Option[] = TYPE_IMAGE_OPTIONS?.map((item: Option) => ({ label: t(item?.label), value: item?.value }));

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [idDownLoading, setIdDownLoading] = useState<number | null>(null);

  const [idFavouring, setIdFavouring] = useState<number | null>(null);

  const [tagSearch, setTagSearch] = useState<any[]>([]);
  const [sortSearch, setSortSearch] = useState<Option | null>(SORT_OPTIONS_LANG[0]);
  const [typeSearch, setTypeSearch] = useState<Option | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [isOpenImportImage, setIsOpenImportImage] = useState<boolean>(false);

  const [images, setImage] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [nextPage, setNextPage] = useState<boolean>(false);

  const [itemEdit, setItemEdit] = useState<any | null>(null);

  const [initialValuesDefault, setInitialValuesDefault] = useState<any | null>(null);

  const [total, setTotal] = useState<number>(0);
  const [params, setParams] = useState<any>({ page: 1, limit: 30, sort_by: SORT_OPTIONS_LANG[0]?.value, order_by: 'DESC', type: '', tags: '' });

  const handleSearch = async () => {
    try {
      if (isLoading) {
        return;
      }
      setIsLoading((_prev) => true);
      const res: any = await getImageLibraryNormal(params);
      if (res?.code === 200) {
        setImage((_prev: any) => (params?.page === 1 ? [...res?.data?.list] : [..._prev, ...res?.data?.list]));
        setNextPage((_prev: any) => (res?.data?.list?.length === Number(params?.limit))); // 
        setTotal((_prev: any) => (res?.data?.pagination?.total));
      }
      setIsLoading((_prev) => false);
    } catch (error: any) {
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      setIsLoading((_prev) => false);
      return error;
    }
  };

  const handleNextPage = () => {
    const _page = params?.page + 1;
    setParams((_prev: any) => ({ ..._prev, page: _page }));
  };


  const onCloseClick = () => {
    setIsOpen((_prev) => false);
  }

  const onCloseEditClick = () => {
    setItemEdit((_prev: any) => null);
  }

  const onCloseImportClick = () => {
    setIsOpenImportImage((_prev) => false);
  }

  const triggerRefreshEdit = (itemNews: any) => {
    setImage((_prev: any) => {
      const _prev_map = _prev?.map((img: any) => (String(img?.id) === String(itemNews?.id) ? itemNews : img));
      return _prev_map;
    });
    onCloseEditClick();
  }

  const triggerRefresh = () => {
    setParams((_prev: any) => ({ ..._prev, page: 1, limit: 30, time_request: +new Date(), }));
    onCloseClick();
    onCloseImportClick();
  }

  const searchData = () => {
    setParams((_prev: any) => (
      {
        ..._prev,
        page: 1,
        tags: (tagSearch || [])?.map((_tag: any) => _tag?.text).join(','),
        type: typeSearch?.value || '',
        sort_by: sortSearch?.value || '',
        time_request: +new Date(),
      }));
  };

  const resetData = () => {
    setParams((_prev: any) => ({
      ..._prev,
      page: 1,
      tags: '',
      type: '',
      sort_by: SORT_OPTIONS_LANG[0]?.value,
      time_request: +new Date(),
    }));
    setTagSearch((_prev: any) => ([]));
    setTypeSearch((_prev: any) => null);
    setSortSearch((_prev: any) => SORT_OPTIONS_LANG[0]);
  }

  const downloadImage = async (imageUrl: string, fileName: string = "downloaded-image", imageId: number) => {
    try {
      const response = await fetch(imageUrl, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName || "downloaded_image.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);

      await patchImageLibrary(imageId, { type: 2 });
      setImage((_prev: any) => {
        const _prev_map = _prev?.map((img: any) => (String(img?.id) === String(imageId) ? ({ ...img, total_downloads: Number(img?.total_downloads) + 1 }) : img));
        return _prev_map;
      });
    } catch (error) {
      toast(`${error || ''}`, CONFIG_OPTION_TOAST_ERROR);
      console.error("Error downloading image:", error);
    }
  };

  const handleActionDownload = async (itemNews: any) => {
    if (!(itemNews?.id) || !!idDownLoading) { return; };
    try {
      setIdDownLoading((_prev) => itemNews?.id);
      const _file_name: string = `${moment().format("YYYYMMDDHHmmss")}_${(itemNews?.download_name || '')?.split('.')?.[0]}_${(itemNews?.tags || []).join('_')}.${(itemNews?.download_name || '')?.split('.')?.[1]}`
      await downloadImage(itemNews?.storage_url, _file_name, itemNews?.id);
      setIdDownLoading((_prev) => null);
    } catch (error: any) {
      setIdDownLoading((_prev) => null);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const handleActionFavorite = async (itemNews: any) => {
    if (!(itemNews?.id) || !!idFavouring) { return; };
    try {
      setIdFavouring((_prev) => itemNews?.id);
      await postImageLibraryFavorite(itemNews?.id);
      setIdFavouring((_prev) => null);
      setImage((_prev: any) => {
        const _prev_map = _prev?.map((img: any) => (String(img?.id) === String(itemNews?.id) ? ({
          ...img,
          is_favorite: Number(!img?.is_favorite),
          total_favorites: Number(img?.total_favorites || 0) + (Number(!img?.is_favorite) ? 1 : -1)
        }) : img));
        return _prev_map;
      });
      // toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
    } catch (error: any) {
      setIdFavouring((_prev) => null);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const handleActionEdit = async (itemNews: any) => {
    setItemEdit((_prev: any) => (itemNews))
  };

  // Begin::Delete
  const handleConfirmDelete = (item: any) => {
    setInitialValuesDefault((_prev: any) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!(initialValuesDefault?.id)) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const data = {
        ids: [initialValuesDefault?.id]
      };
      const response: any = await deleteImageLibrary(data);
      if (response?.code === 200) {
        setImage((_prev: any) => {
          const _prev_map = _prev?.filter((img: any) => (String(img?.id) !== String(initialValuesDefault?.id)));
          return _prev_map;
        });
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev: any) => null);
        setTotal((_prev: any) => (Number(_prev) - 1));
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev: any) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete


  useEffect(() => {
    if (params) {
      handleSearch();
    }
  }, [JSON.stringify(params)]);

  useEffect(() => {
    document.title = `${t('Home')} - ${t('Image Repository')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Image Repository')} pageTitle={t('Home')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.IMAGE_REPOSITORY, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-sm-2">
                        <div>
                          <h5 className="card-title mb-0">
                            <span>
                              <span className="me-2">{t('Total')}:</span>
                              {(isLoading && params?.page === 1) ? <Spinner size="sm text-primary" ></Spinner> : <CountUp
                                start={0}
                                end={total || 0}
                                duration={1}
                                className="text-primary"
                              />}
                            </span>
                          </h5>
                        </div>
                      </div>
                      <div className="col-sm-10 text-end d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-success add-btn rounded-pill"
                          id="create-btn"
                          onClick={() => setIsOpen((_prev) => true)}
                        >
                          <i className="ri-add-line align-bottom me-1"></i>
                          {t('Button Upload Image')}
                        </button>
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <Row className="g-4 align-items-center mt-0">
                      <Col sm={12} md={12} lg={12} xl={12} xxl={12} className='mt-3 mt-xxl-2 d-flex flex-wrap gap-2 gap-md-3'>
                        <LabelWrapper label={t('Sorting')} isShow={true}>
                          <DropdownOption
                            name="sort"
                            dataList={SORT_OPTIONS_LANG || []}
                            placeholder={`${t("Sorting")}...`}
                            className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                            classNamePrefix="name-prefix"
                            style={{ width: i18n?.language === 'en' ? '180px' : '150px' }}
                            initialValue={sortSearch}
                            isHaveMoreInfo={true}
                            onChangeSelect={(e: any) => {
                              setSortSearch(e);
                            }}
                          />
                        </LabelWrapper>
                        <LabelWrapper label={t('Type')} isShow={true}>
                          <DropdownOption
                            name="type"
                            dataList={TYPE_OPTIONS_LANG || []}
                            placeholder={`${t("Type")}...`}
                            className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                            classNamePrefix="name-prefix"
                            style={{ width: i18n?.language === 'en' ? '180px' : '150px' }}
                            initialValue={typeSearch}
                            isHasOptionAll={true}
                            optionAll={{
                              label: t('All'),
                              value: ''
                            }}
                            onChangeSelect={(e: any) => {
                              setTypeSearch(e);
                            }}
                          />
                        </LabelWrapper>
                        <div className="flex-grow-1 " style={{ minWidth: '300px' }}>
                          <LabelWrapper label={t('Tags')} isShow={!!tagSearch} >
                            <Hashtag
                              name="tags"
                              placeholder={`${t("Search by tags")}...`}
                              suggestions={[]}
                              initialValue={tagSearch || []}
                              onChangeTag={(event: any) => {
                                setTagSearch(event);
                              }}
                              idSelected="hashtags-CampaignFormMulti"
                              maxHashtags={2000}
                              maxHeight="150px"
                            />
                          </LabelWrapper>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-2 me-lg-2"
                            onClick={searchData}
                            disabled={isLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t('Button Reset')}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-3 px-3">
                    <InfiniteScroll
                      dataLength={images?.length || 0}
                      next={handleNextPage}
                      scrollableTarget='scrollableDiv'
                      hasMore={nextPage}
                      loader={''} // loader={<LoadingListNotify />}
                      scrollThreshold={'50%'}
                    >
                      <div className="h-100 overflow-y-hidden overflow-x-hidden">
                        <Row className="box-google-image">
                          <Col sm={12}>
                            <Masonry className="row gallery-wrapper ">
                              {images?.map((item: any, index: number) => (
                                <Col xxl={3} xl={4} sm={6} className="element-item project designing development px-0" key={item?.id}>
                                  <ImageBox info={item} handleActionFavorite={handleActionFavorite} handleActionDownload={handleActionDownload} handleActionEdit={handleActionEdit} handleConfirmDelete={handleConfirmDelete} />
                                </Col>
                              ))}
                            </Masonry>
                            <div className="text-center my-2">
                              {!!isLoading ? <Spinner size="sm" className="text-primary fs-20 align-middle" style={{ width: '40px', height: '40px' }}></Spinner> : ((images?.length === 0) && <span className="fs-18 text-muted">{t('No data')}</span>)}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </InfiniteScroll>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={isOpen}
          centered={true}
          size="xl"
          scrollable={true}
        >
          <ModalHeader toggle={onCloseClick}>
            <>{t("Button Upload Image")}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <div>
              <LibraryForm
                triggerRefresh={triggerRefresh}
              />
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={!!itemEdit?.id}
          centered={true}
          size="md"
          scrollable={false}
        >
          <ModalHeader toggle={onCloseEditClick}>
            <>{t("Button Update Image")}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <div>
              <LibraryEditForm
                itemEdit={itemEdit}
                triggerRefresh={triggerRefreshEdit}
              />
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isOpenImportImage}
          centered={true}
          size="md"
          scrollable={false}
        >
          <ModalHeader toggle={() => setIsOpenImportImage((_prev) => false)}>
            <>{t("Button Upload Bulk Images")}</>
          </ModalHeader>
          <ModalBody className="pt-2">
            <div style={{ minHeight: "170px" }}>
              <ImportImageBulkForm
                triggerRefresh={triggerRefresh}
              />
            </div>
          </ModalBody>
        </Modal>

        <ModalConfirm
          header={t('Button Delete Image')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default ImageRepository;

